const relatedNews = document.querySelectorAll('[data-slider="related-news"]');

const relatedNewsOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1600: {
      slidesPerView: 4,
      spaceBetween: 48,
    },
  },
};

relatedNews.forEach((el) => {
  new Swiper(el, relatedNewsOptions);
});
